import { injectable } from 'inversify';
import axios, { AxiosRequestTransformer, AxiosResponseTransformer } from 'axios';
import { UserService } from '../services/UserService';
import { AxiosReviver, AxiosSerializer, Contexts, NamedBindings, getContainer } from '@dandelion/core';
import { AdmissionIdAndHash, ImportCache } from './ReadmissionChainForPatientKeyStorage';

@injectable()
export class ImportHashRestStorage {
  protected STORAGE_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

  protected axiosInstance = axios.create({
    transformRequest: [
      AxiosSerializer,
      ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
    ],
    transformResponse: [
      ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
      AxiosReviver,
    ],
  });
  constructor(
  ) {
    const userService = getContainer(Contexts.SHARED).get(NamedBindings.UserService) as UserService
    this.axiosInstance.interceptors.request.use((config: any) => {
      config.headers = userService.getHeaders();
      return config;
    });
  }

  async save(patientKey: string, admissionIdAndHash: AdmissionIdAndHash) {
    await this.axiosInstance.post(
      this.STORAGE_BASE_URL + `Readmission/chainsForPatientKey/${patientKey}/`, admissionIdAndHash)
    return;
  }

  async getCache(): Promise<ImportCache> {
    return (await this.axiosInstance.get(this.STORAGE_BASE_URL + `Readmission/chainsForPatientKey/`)).data as ImportCache;
  }
}
